import { RiskLevel } from '@models/assessment';

import { Gender } from 'generated/types';

import type { ReferenceRange } from './types';

const referenceRange: ReferenceRange<RiskLevel> = new Map([
  [
    Gender.male,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            lower: 43,
            upper: 80,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 36,
            upper: 43,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 10,
            upper: 36,
          },
        ],
      ],
    ]),
  ],
  [
    Gender.female,
    new Map([
      [
        RiskLevel.Low,
        [
          {
            lower: 34,
            upper: 80,
          },
        ],
      ],
      [
        RiskLevel.Medium,
        [
          {
            lower: 29,
            upper: 34,
          },
        ],
      ],
      [
        RiskLevel.High,
        [
          {
            lower: 10,
            upper: 29,
          },
        ],
      ],
    ]),
  ],
]);

export default referenceRange;
